import React from "react";
import { createRoot } from "react-dom/client";
import "./styles/global.css";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import DataProvider from "./redux/store";
import { persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <PersistGate loading={null} persistor={persistor}>
        <DataProvider>
          <App />
        </DataProvider>
      </PersistGate>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
